import { combineReducers } from 'redux';
import tenantAdmins from './tenantAdmins';
import tenantList from './tenantList';
import tenant from './tenant';
import currTenantId from './currTenantId';
import currTenantAdmin from './currTenantAdmin';
import storm360Admins from './storm360Admins';
import storm360Users from './storm360Users';
import tenantPendingUsers from './tenantPendingUsers';
import pendingStorm360Admins from './pendingStorm360Admins';
import tenantsForSharedUser from './tenantsForSharedUser';

const tenantsData = combineReducers({
  tenantAdmins,
  tenantList,
  tenant,
  currTenantId,
  currTenantAdmin,
  storm360Admins,
  storm360Users,
  tenantPendingUsers,
  pendingStorm360Admins,
  tenantsForSharedUser,
});

export * from './tenantAdmins';
export * from './tenantList';
export * from './tenant';
export * from './currTenantId';
export * from './currTenantAdmin';
export * from './storm360Admins';
export * from './storm360Users';
export * from './tenantPendingUsers';
export * from './pendingStorm360Admins';
export * from './tenantsForSharedUser';

export default tenantsData;
